// const listaDeUsuarios = (state) => {
//     return state.items || [];
// }

// const loadingUsuario = (state) => {
//     return state.buscando
// }

const listaMenus = (state) => {
    return state.menus
}

const perfilSelecionado = (state) => {
    return state.perfil
}

// const perfilSelecionadoComMenus = (state) => {
//     return state.selecionado
// }

const listaMenusPorPerfis = (state) => {
    return state.menusPorPerfis
}

const loadingPerfisMenus = (state) => {
    return state.buscando
}

export {
    // listaDeUsuarios,
    // loadingUsuario,
    listaMenus,
    perfilSelecionado,
    // perfilSelecionadoComMenus,
    listaMenusPorPerfis,
    loadingPerfisMenus
}